import {
    IConfigGeral,
    IConfigGeralPortalAdmin,
    IMensagemTransferencia,
} from "../../../../Interfaces/Geral/GestaoDeCadastro/ConfigGeral/ConfigGeralInterface";

import Axios from "../../../Config/API";
import Service from "../../../Service";

export async function GetConfigGeralService() {
    return Service(
        Axios.get<IConfigGeral>(
            `/home/configgeral/getconfiggeral?idConfigGeral=1`
        )
    );
}

export async function AtualizarConfigGeralService(requestBody: IConfigGeral) {
    return Service(
        Axios.put<IConfigGeral>(
            `/home/configgeral/atualizarconfiggeral`,
            requestBody
        )
    );
}

export async function ListarConfiguracoesGeraisService(ID_MODULO: number) {
    return await Axios.get<Array<IConfigGeralPortalAdmin>>(
        `/home/configgeral/getlistconfiggeral?idModulo=${ID_MODULO}`
    );
}

export async function AtualizarConfigGeralPortalAdmService(
    data: Array<IConfigGeralPortalAdmin>
) {
    return Service(
        Axios.put<IConfigGeralPortalAdmin>(
            `/home/configgeral/atualizarconfiggeralv2`,
            data
        )
    );
}

export async function ListarMensagemTransferenciaService() {
    return Service(
        Axios.get<IMensagemTransferencia>(
            `/helpdesk/respostaschat/listarmensagemtransferencia`
        )
    );
}

export async function CadastrarMensagemTransferenciaService(
    requestBody: IMensagemTransferencia
) {
    return Service(
        Axios.post(
            `/helpdesk/respostaschat/cadastrarmensagemtransferencia`,
            requestBody
        )
    );
}

export async function VerificarIntegracaoMetaService() {
    return Service(Axios.post(`/helpdesk/meta/verificarintegracaometa`));
}
